import React from 'react';
import { MuiButton } from '@ace/ace-ui-web';
import { Stack } from '@mui/material';
import { motion } from 'framer-motion';
import { LoadingSpinner } from '../loading-spinner';

interface SaveButtonProps {
    label?: string;
    disabled?: boolean;
    updating?: boolean;
    onSave?: () => void;
}

export const SaveButton: React.FC<SaveButtonProps> = ({
    label = "Save Changes",
    disabled = false,
    updating = false,
    onSave,
}) => {
    const buttonContent = updating ? <LoadingSpinner /> : label;

    return (
        <Stack direction="row" justifyContent="center" alignItems="center" sx={{ mt: 1 }}>
            <motion.div
                whileHover={{ scale: 1.01 }}
                whileTap={{ scale: 0.99 }}
                style={{ width: '100%', display: 'flex' }}
            >
                <MuiButton size="large" disabled={disabled} onClick={onSave}>
                    {buttonContent}
                </MuiButton>
            </motion.div>
        </Stack>
    );
};